import React from "react";

export const AlertIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41675 8.08332L6.41675 5.74999C6.41675 5.42782 6.67791 5.16666 7.00008 5.16666C7.32225 5.16666 7.58341 5.42782 7.58341 5.74999L7.58342 8.08332C7.58342 8.40549 7.32225 8.66666 7.00008 8.66666C6.67792 8.66666 6.41675 8.40549 6.41675 8.08332Z"
        fill="#EF4444"
      />
      <path
        d="M7.00008 11C7.32225 11 7.58342 10.7388 7.58342 10.4167C7.58342 10.0945 7.32225 9.83332 7.00008 9.83332C6.67792 9.83332 6.41675 10.0945 6.41675 10.4167C6.41675 10.7388 6.67792 11 7.00008 11Z"
        fill="#EF4444"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.00008 1.66666C7.44198 1.66666 7.84596 1.91633 8.04358 2.31157L12.7102 11.6449C12.8911 12.0066 12.8717 12.4361 12.6592 12.78C12.4466 13.124 12.0711 13.3333 11.6667 13.3333H2.33342C1.92908 13.3333 1.55356 13.124 1.34099 12.78C1.12842 12.4361 1.10909 12.0066 1.28992 11.6449L5.95658 2.31157C6.15421 1.91633 6.55818 1.66666 7.00008 1.66666ZM2.33342 12.1667H11.6667L7.00008 2.83332L2.33342 12.1667Z"
        fill="#EF4444"
      />
    </svg>
  );
};
